export const INDUSTRY = [
    'Adult Entertainment',
    'Agriculture & Farming',
    'Animals & Wildlife',
    'Anime & Otaku Culture',
    'Art & Design',
    'Astrology & Horoscope',
    'Automotive',
    'Beauty & Personal Care',
    'Blogging & Vlogging',
    'Books & Publishing',
    'Business & Startups',
    'Cannabis & CBD',
    'Career & Job Search',
    'Celebrities & Gossip',
    'Charity & Activism',
    'Comics & Graphic Novels',
    'Conspiracy Theories',
    'Cooking & Recipes',
    'Crafts & DIY',
    'Cryptocurrency',
    'Culture & Society',
    'Dance',
    'Dating & Relationships',
    'Design & UX',
    'Education',
    'E-commerce',
    'Entertainment & Media',
    'Entrepreneurship',
    'Esports',
    'Events & Experiences',
    'Family & Parenting',
    'Fashion',
    'Finance & Banking',
    'Fitness & Sports',
    'Food & Beverage',
    'Gaming',
    'Gambling',
    'Gardening',
    'Health & Wellness',
    'History & Facts',
    'Hobbies & Interests',
    'Home & Living',
    'Humor & Memes',
    'Interior Design',
    'K-pop & J-pop',
    'Legal & Law',
    'Lifestyle',
    'Luxury Goods',
    'Marketing & Advertising',
    "Men's Interests",
    'Mental Health',
    'Movies & TV',
    'Music & Nightlife',
    'Mythology & Folklore',
    'Nature & Outdoors',
    'News & Commentary',
    'Non-profit & Social Impact',
    'Parenting & Family',
    'Paranormal & Supernatural',
    'Pet Care',
    'Photography & Videography',
    'Politics & Commentary',
    'Professional Services',
    'Real Estate',
    'Religion & Faith',
    'Reviews & Unboxings',
    'Science & Innovation',
    'Self-Improvement',
    'Sexual Wellness',
    'Spirituality & Mindfulness',
    'Sustainability & Eco-Friendly',
    'Technology & Electronics',
    'Toys & Collectibles',
    'Travel & Hospitality',
    'True Crime',
    'Veganism & Plant-based Living',
    'Virtual Reality & Metaverse',
    'Weddings & Relationships',
    'Wellness Retreats & Healing',
    "Women's Interests",
];

export const SERVICE = [
    // Design & Branding
    'Visual identity design',
    'Logo design',
    'Brand guidelines development',
    'Style guide creation',
    'Print design (flyers, posters, brochures)',
    'Merchandise design',
    'Packaging design',
    'Album and cover art design',
    'Event branding',
    'Motion branding (animated brand assets)',

    // Illustration
    'Character illustration',
    "Children's book illustration",
    'Editorial illustration',
    'Vector art creation',
    'Comic and storyboard illustration',
    'Concept art',
    'Tattoo design',
    'Illustrated typography',

    // Animation
    '2D animation',
    '3D animation',
    'Explainer videos',
    'Animated infographics',
    'Character animation',
    'Motion graphics',
    'Logo animation',
    'Title and credit sequences',
    'Kinetic typography',
    'Cel (frame-by-frame) animation',
    'Stop-motion animation',
    'Virtual reality (VR) animation',
    'Augmented reality (AR) animation',
    'Animation for games/apps',

    // Video & Film Production
    'Short film production',
    'Feature film production',
    'Documentary filmmaking',
    'TV/web series production',
    'Music video production',
    'Commercial/ad video production',
    'Cinematography',
    'Directing',
    'Scriptwriting',
    'Storyboarding',
    'Casting',
    'Talent booking',
    'Location scouting',
    'Location permits and clearance',
    'Set design and construction',
    'Props and wardrobe sourcing',
    'Costume design',
    'Makeup and styling',
    'On-set photography',
    'On-set video assist services',
    'Lighting design and setup',
    'Drone videography',
    'Production scheduling and planning',
    'Production management',
    'Field production support',
    'Behind-the-scenes (BTS) documentation',

    // On-Set & Production Support
    'Production assistants',
    'Line producing',
    'Catering and craft services',
    'Wardrobe and wardrobe assistants',
    'Transportation coordination',
    'Hair and makeup artists',
    'On-set medic services',
    'Security and crowd control',
    'Equipment rental (camera, lighting, sound)',
    'Call sheet creation and management',
    'Union and compliance coordination',

    // Post-Production
    'Video editing',
    'Color correction',
    'Color grading',
    'Visual effects (VFX)',
    'Green screen keying',
    'Sound design',
    'Voice-over recording',
    'Audio mixing and mastering',
    'Subtitles and captions',
    'Dialogue editing (ADR)',
    'Foley effects',
    'Music scoring',
    'Post-production supervision',
    'Media transcoding and delivery',

    // Photography (Creative/Fashion/Artistic)
    'Fashion photography',
    'Editorial photography',
    'Film stills photography',
    'Portrait sessions',
    'Fine art photography',
    'Creative product photography',
    'Behind-the-scenes photography',
    'Lookbook and campaign shoots',

    // Creative Direction & Art Direction
    'Art direction for campaigns',
    'Creative direction for shoots',
    'Moodboard and concept development',
    'Photo/video set styling',
    'Creative consulting',
    'Pitch deck and treatment design',

    // Digital Experiences
    'Interactive storytelling experiences',
    'Creative microsite design',
    'Web design for artists/creatives',
    'Portfolio development',
    'Immersive exhibition design',
    'NFT art creation and animation',
    'AR filters and effects',
    'Virtual galleries and showrooms',

    // Theatre & Performance Media
    'Stage lighting design',
    'Projection design',
    'Multimedia set design',
    'Performance documentation',
    'Promo video for plays/shows',
    'Theatrical video installations',

    // Content for Social & Brands
    'Instagram reels/TikTok content production',
    'Campaign concepting and production',
    'Branded visual storytelling',
    'Content series for social platforms',
    'Influencer creative content',
    'Creative brand partnerships',

    // Education & Training
    'Animation workshops',
    'Creative storytelling bootcamps',
    'Filmmaking masterclasses',
    'Design mentorship programs',
    'Scriptwriting clinics',
    'Acting for camera workshops',

    'Media services',

    'Software as a Service',
];

export const COMPANY_TYPES = [
    'advertising agency',
    'animation studio',
    'architectural firm',
    'casting agency',
    'community art collective',
    'content agency',
    'content creator collective',
    'creative agency',
    'creative consultancy',
    'design studio',
    'digital publishing company',
    'event production company',
    'experiential agency',
    'experiential lab',
    'fashion brand',
    'film studio',
    'game studio',
    'illustration studio',
    'independent publisher',
    'influencer agency',
    'innovation lab',
    'interactive media company',
    'marketing agency',
    'media company',
    'metaverse studio',
    'motion graphics studio',
    'music label',
    'nonprofit arts organization',
    'photography studio',
    'podcast network',
    'post-production studio',
    'production house',
    'publishing house',
    'recording studio',
    'software company',
    'streaming platform',
    'talent agency',
    'theatre company',
    'visual effects (vfx) studio',
    'vr/ar studio',
    'web3 creative collective',
];

export const LEADERSHIP_POSITIONS = [
    'CEO',
    'Creative Director',
    'Managing Director',
    'Producer',
    'COO',
    'CTO',
    'Founder',
    'Co-Founder',
    'Art Director',
    'Head of Production',
    'Head of Marketing',
    'Other',
];
